const promo = {
  /**
   * 选择商城的label
   */
  filterText: '品牌',
  filterText_: '商城',
  add: '添加',
  /**
   * 活动类型的label
   */
  promoTypeLabel: '活动类型',
  /**
   * 未选择时的提示语
   */
  promoTypePlacement: '全部',

  button: {
    export: '导出',
    reset: '重置',
    submit: '提交',
    promoExport: '活动信息',
    skuExport: 'SKU活动信息详情',
    skuExportMsg: '请选择商城',
  },
  tableTitle: '活动统计',
  /**
   * 商城活动页面标题前缀
   */
  shopPageTitle: '',
  /**
   * 品牌活动页面标题前缀
   */
  brandPageTitle: '',
  table: {
    promoInfoCH: '活动信息 (CH)',
    promoInfoEN: '活动信息 (EN)',
    startDate: '开始时间',
    endDate: '结束时间',
    disscount: '折扣率',
    promoType: '活动类型',
    skuAmt: '商品数量',
    brandsAmt: '品牌数量',
    shopName: '商城名称',
  },
  modal: {
    skuModal: {
      title: 'SKU',
      table: {
        image: '图片',
        code: 'Code',
        name: '名称',
        brand: '品牌',
        price: '价格',
        msg: `(1) 单击以查看受监控商店中的价格和价格比较信息。
        (2) 零售价格 (Ret-p)：      
        零售价是指商场官网上显示的销售价格，不包括促销 (包括但不限于折扣、回扣等)。
        (3) 最优价格 (Dis Price)：    
        最优价格是所有折扣（包括但不限于折扣、回扣等）最佳组合后的最终价格。`,
      },
      skuTable: {
        shopName: '商城名称',
        cur: '币种',
        retP: '原价',
        retPCurrency: '原价({0})',
        optPCountry: '折扣价({0})',
      },
    },
    selectShopModal: {
      title: '选择商城',
    },
    selectBrandModal: {
      title: '选择品牌',
    },
    brandModal: {
      title: '选择品牌',
      table: {
        brand: '品牌',
        skuAmount: '商品数量',
        SKUDetails: 'SKU详情',
      },
      subTable: {
        image: '图片',
        code: 'Code',
        brand: '品牌',
        operation: '操作',
        operationBtn: '查看',
      },
    },
    detailModal: {
      title: '详情',
      table: {
        name: '商城名称',
        price: '店面价',
        usd: 'USD',
        discount: '折扣',
        index: 'index',
        priceGrading: '价格评分',
      },
    },
    downloadModal: {
      title: '导出活动数据',
      form: {
        choose: '是否导出sku详情',
        text: '为防止导出数据超出Excel最大限制，导出sku条件只能导出一天数据',
        yes: '是',
        no: '否',
        time: '时间表',
      },
      table: {
        ch: '活动中文',
        en: '活动英文',
        type: '活动类型',
        start: '开始时间',
        end: '结束时间',
        cheap: '活动优惠值',
        code: 'Code',
        brand: '品牌',
        detail: '商品名称',
        price: '商品原价',
      },
    },
  },
};

export default { promo };
